const COUNTRY_CURRENCY_MAP = {
  'US': 'USD',
  'FR': 'EUR',
  'DE': 'EUR',
  'IT': 'EUR',
  'ES': 'EUR',
  'NL': 'EUR',
  'BE': 'EUR',
  'PT': 'EUR',
  'AT': 'EUR',
  'IE': 'EUR',
  'FI': 'EUR',
  'GR': 'EUR',
  'GB': 'GBP',
  // 'UK': 'GBP', // UK is not an official ISO code, GB is preferred
  'CA': 'CAD',
  'JP': 'JPY',
  'CN': 'CNY',
  'AU': 'AUD',
  'NZ': 'NZD',
  'CH': 'CHF',
  'SE': 'SEK',
  'DK': 'DKK',
  'NO': 'NOK'
  // Add more mappings as needed
};

export const getCurrencyFromCountry = (countryCode) => {
  if (!countryCode) return 'USD'; // Default if no country code
  return COUNTRY_CURRENCY_MAP[countryCode.toUpperCase()] || 'USD'; // Default to USD if country code not found
}; 